import { useCallback, useContext } from "react";

import { PrescricaoContext } from "../contexts/PrescricaoContext";

import MaskService from "../../../../utils/mask/maskService";

import { useHistory } from "react-router";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { notify } from "../../../../utils/notify";

import {
  createPrescricao,
  updatePrescricao,
  findPrescricao,
} from "../../../../repositories/qerpapi/erp/optica/v1/PrescricaoRepository";
import { formatDate } from "../../../../utils/formatDate";

import {
  createClienteColaborador,
  updateClienteColaborador,
} from "../../../../repositories/qerpapi/erp/prouser/v1/ClientesColaboradoresRepository";

export default function usePrescricaoController() {
  const {
    prescricaoId,
    setPrescricaoId,
    setExpanded,
    dataColabTable,
    setDataColabTable,

    clienteFilter,
    setClienteFilter,
    setcolaboradorFilter,
    setAddColabOpen,
    colaboradorSelected,
    setColaboradorSelected,

    setLocalFilter,
    produtoLenteCodigo,
    setProdutoLenteCodigo,
    setProdutoLenteDescricaoSelected,
    produtoAroCodigo,
    setProdutoAroCodigo,
    setProdutoAroDescricaoSelected,

    lenteTipoSelected,
    setLenteTipoSelected,
    lenteTratamentoSelected,
    setLenteTratamentoSelected,
    lenteReflexoSelected,
    setLenteReflexoSelected,
    lenteRiscoSelected,
    setLenteRiscoSelected,
    lenteODEsf,
    setLenteODEsf,
    lenteODCili,
    setLenteODCili,
    lenteODEixo,
    setLenteODEixo,
    lenteODDNP,
    setLenteODDNP,
    lenteOEEsf,
    setLenteOEEsf,
    lenteOECili,
    setLenteOECili,
    lenteOEEixo,
    setLenteOEEixo,
    lenteOEDNP,
    setLenteOEDNP,
    lenteAdicao,
    setLenteAdicao,
    lenteAltura,
    setLenteAltura,
    lenteSelected,
    setLenteSelected,

    aroCor,
    setAroCor,
    aroTamanho,
    setAroTamanho,
    aroAjuste,
    setAroAjuste,
    aroHaste,
    setAroHaste,
    aroFrente,
    setAroFrente,

    colabNome,
    setColabNome,
    colabEmail,
    setColabEmail,
    colabCPF,
    setColabCPF,
    colabRG,
    setColabRG,
    colabActive,
    setColabActive,
    colabId,
    setColabId,

    precricaoDataValidade,
    setPrecricaoDataValidade,
    receitaTObs,
    setReceitaTObs,
    setAutoVariavies,
  } = useContext(PrescricaoContext);
  const { push, go } = useHistory();
  const { queryParams } = useContext(QueryParamsContext);

  const handleChangeOpenAcordion = (accordion) => {
    setExpanded((current) => ({
      ...current,
      [accordion]: !current[accordion],
    }));
  };

  const clientGetOptionLabel = (option) => {
    return `${option.razao} ${
      option.cpfcnpj
        ? `(${MaskService.toMask(
            option.cpfcnpj.replace(/[^0-9]+/g, "").length === 11
              ? "cpf"
              : "cnpj",
            option.cpfcnpj
          )})`
        : ""
    }`;
  };

  const HandleAddModalColaborador = (colaborador) => {
    setColabNome(colaborador.nome);
    setColabEmail(colaborador.email);
    setColabCPF(colaborador.cpf);
    setColabRG(colaborador.rg);
    setColabActive(colaborador.ativo === "S");
    setColabId(colaborador.id);
    setAddColabOpen(true);
  };
  const clearColaborador = () => {
    setColabNome("");
    setColabEmail("");
    setColabCPF("");
    setColabRG("");
    setColabActive(true);
    setColabId(null);
  };

  const handleAddColaborador = () => {
    let newDataColabTable = [...dataColabTable];
    if (!colabId) {
      let newColab = [];
      newColab.nome = colabNome;
      newColab.email = colabEmail;
      newColab.cpf = colabCPF;
      newColab.rg = colabRG;
      newColab.ativo = colabActive ? "S" : "N";
      newColab.cliente_id = clienteFilter?.id;
      newDataColabTable.push(newColab);
    } else {
      for (const colaborador of newDataColabTable) {
        if (colaborador.id === colabId) {
          colaborador.cpf = colabCPF;
          colaborador.rg = colabRG;
          colaborador.ativo = colabActive ? "S" : "N";
          colaborador.nome = colabNome;
        }
      }
    }
    setDataColabTable(newDataColabTable);
    setAddColabOpen(false);
    clearColaborador();
  };

  const handleAddPrescricao = async (again) => {
    let idColab = null;
    if (colaboradorSelected[0]?.nome) {
      let resultSubmitColab = null;
      const dataColaborador = {
        cliente_id: colaboradorSelected[0].cliente_id,
        nome: colaboradorSelected[0].nome,
        email: colaboradorSelected[0].email,
        cpf: colaboradorSelected[0].cpf,
        rg: colaboradorSelected[0].rg,
        ativo: colaboradorSelected[0].ativo,
      };
      if (colaboradorSelected[0]?.id) {
        resultSubmitColab = await updateClienteColaborador(
          colaboradorSelected[0].id,
          queryParams.empresa_cnpj,
          {
            clientecolaborador: dataColaborador,
          }
        );
        idColab = resultSubmitColab?.data?.id;
      } else {
        resultSubmitColab = await createClienteColaborador(
          queryParams.empresa_cnpj,
          {
            clientecolaborador: dataColaborador,
          }
        );
        idColab = resultSubmitColab?.data?.id;
      }
    }
    let dataPrescricao = {
      od_esferico: lenteODEsf,
      od_cilindrico: lenteODCili,
      od_eixo: lenteODEixo,
      od_dnp: lenteODDNP,
      oe_esferico: lenteOEEsf,
      oe_cilindrico: lenteOECili,
      oe_eixo: lenteOEEixo,
      oe_dnp: lenteOEDNP,
      od_altura: lenteAltura,
      od_adicao: lenteAdicao,
      oe_altura: lenteAltura,
      oe_adicao: lenteAdicao,
      tipo_coloracao: aroCor,
      coloracao: aroCor === "" ? false : true,
      tamanho: aroTamanho,
      receita_data: precricaoDataValidade,
      observacoes: receitaTObs,
      antireflexo: lenteReflexoSelected === "S" ? true : false,
      antirisco: lenteRiscoSelected === "S" ? true : false,
      tirartensao: aroHaste === "S" ? true : false,
      abrirfrente: aroFrente === "S" ? true : false,
      cliente_colaborador_id: idColab,
      ajustes: aroAjuste?.label,
      tipo_lente: lenteTipoSelected?.descricao,
      tratamento_lente: lenteTratamentoSelected?.descricao,
      especificacao_lente: lenteSelected.label,
      od_dp: lenteODDNP + lenteOEDNP,
      oe_dp: lenteODDNP + lenteOEDNP,
      lente_codigo: produtoLenteCodigo,
      aro_codigo: produtoAroCodigo,
    };
    // criar novas colunas, lente_estoque_id, aro_estoque_id,
    let resultSubmit = null;

    if (prescricaoId) {
      resultSubmit = await updatePrescricao(
        prescricaoId,
        queryParams.empresa_cnpj,
        {
          prescricao: dataPrescricao,
        }
      );
    } else {
      resultSubmit = await createPrescricao(queryParams.empresa_cnpj, {
        prescricao: dataPrescricao,
      });
    }

    if (resultSubmit && resultSubmit.success) {
      setPrescricaoId(null);
      if (again) {
        push(
          `cadastro?empresa_cnpj=${
            queryParams?.empresa_cnpj || ""
          }&empresa_id=${queryParams?.id || ""}`
        );
        go(0);
        clearAll();
        return notify("Receita salva com sucesso.", true, "success");
      } else {
        push(
          `/optica/prescricao/listagem?empresa_cnpj=${
            queryParams?.empresa_cnpj || ""
          }&empresa_id=${queryParams?.id || ""}`
        );
        clearAll();
        return notify("Receita salva com sucesso.", true, "success");
      }
    }
    return notify("Não foi possível salvar os dados da receita.");
  };

  const handleAutoPrescricao = useCallback(
    async (item) => {
      let listOptions = [
        {
          label: "SIM",
          id: "S",
        },
        {
          label: "NÃO",
          id: "N",
        },
      ];
      let resultPrescricao = await findPrescricao({
        empresa_cnpj: queryParams?.empresa_cnpj ? queryParams.empresa_cnpj : "",
        id: item.id,
        include: "clientecolaborador, clientecolaborador.cliente",
      });
      if (resultPrescricao.success) {
        setClienteFilter(
          resultPrescricao?.data?.clientecolaborador?.cliente || []
        );
        setColaboradorSelected([
          {
            id: resultPrescricao?.data?.clientecolaborador?.id || "",
            cliente_id:
              resultPrescricao?.data?.clientecolaborador?.cliente_id || "",
            nome: resultPrescricao?.data?.clientecolaborador?.nome || "",
            email: resultPrescricao?.data?.clientecolaborador?.email || "",
            ativo: resultPrescricao?.data?.clientecolaborador?.ativo || "",
            cpf: resultPrescricao?.data?.clientecolaborador?.cpf || "",
            rg: resultPrescricao?.data?.clientecolaborador?.rg || "",
          },
        ]);
        setPrescricaoId(item.id);
        setLenteODEsf(resultPrescricao?.data?.od_esferico || "");
        setLenteODCili(resultPrescricao?.data?.od_cilindrico || "");
        setLenteODEixo(resultPrescricao?.data?.od_eixo || "");
        setLenteODDNP(resultPrescricao?.data?.od_dnp || "");
        setLenteOEEsf(resultPrescricao?.data?.oe_esferico || "");
        setLenteOECili(resultPrescricao?.data?.oe_cilindrico || "");
        setLenteOEEixo(resultPrescricao?.data?.oe_eixo || "");
        setLenteOEDNP(resultPrescricao?.data?.oe_dnp || "");
        setLenteAltura(resultPrescricao?.data?.od_altura || "");
        setLenteAdicao(resultPrescricao?.data?.od_altura || "");
        setAroCor(resultPrescricao?.data?.tipo_coloracao || "");
        setAroTamanho(resultPrescricao?.data?.tamanho || "");
        setPrecricaoDataValidade(resultPrescricao?.data?.receita_data || "");
        setReceitaTObs(resultPrescricao?.data?.observacoes || "");
        setAroAjuste(
          [
            {
              label: "Manter Ajuste",
              id: "M",
            },
            {
              label: "Ajustar Ponteira",
              id: "P",
            },
            {
              label: "Ajustar + Ponteira",
              id: "MP",
            },
          ].find((type) => type.label === resultPrescricao?.data?.ajustes) ||
            null
        );
        setLenteSelected(
          [
            {
              label: "Par",
              id: "P",
            },
            {
              label: "Direita",
              id: "D",
            },
            {
              label: "Esquerda",
              id: "E",
            },
          ].find(
            (type) => type.label === resultPrescricao?.data?.especificacao_lente
          ) || null
        );
        setAutoVariavies({
          tipoLente: resultPrescricao?.data?.tipo_lente || "",
          tratamentoLente: resultPrescricao?.data?.tratamento_lente || "",
        });
        setLenteReflexoSelected(
          listOptions.find((type) =>
            type.label === resultPrescricao?.data?.antireflexo ? "S" : "N"
          ) || null
        );
        setLenteRiscoSelected(
          listOptions.find((type) =>
            type.label === resultPrescricao?.data?.antirisco ? "S" : "N"
          ) || null
        );
        setAroHaste(
          listOptions.find((type) =>
            type.label === resultPrescricao?.data?.tirartensao ? "S" : "N"
          ) || null
        );
        setAroFrente(
          listOptions.find((type) =>
            type.label === resultPrescricao?.data?.abrirfrente ? "S" : "N"
          ) || null
        );
        setProdutoAroCodigo(resultPrescricao?.data?.aro_codigo || "");
        setProdutoLenteCodigo(resultPrescricao?.data?.lente_codigo || "");
      }
    },
    [
      queryParams,
      setLenteODEsf,
      setLenteODCili,
      setLenteODEixo,
      setLenteODDNP,
      setLenteOEEsf,
      setLenteOECili,
      setLenteOEEixo,
      setLenteOEDNP,
      setLenteAltura,
      setLenteAdicao,
      setAroCor,
      setAroTamanho,
      setPrecricaoDataValidade,
      setReceitaTObs,
      setAroAjuste,
      setLenteSelected,
      setPrescricaoId,
      setAroFrente,
      setAroHaste,
      setLenteReflexoSelected,
      setLenteRiscoSelected,
      setClienteFilter,
      setColaboradorSelected,
      setAutoVariavies,
      setProdutoLenteCodigo,
      setProdutoAroCodigo,
    ]
  );

  const handleBackSubmit = () => {
    clearAll();
    push(
      `/optica/prescricao/listagem?empresa_cnpj=${
        queryParams?.empresa_cnpj || ""
      }&empresa_id=${queryParams?.id || ""}`
    );
  };

  const clearAll = () => {
    setPrescricaoId(null);
    setDataColabTable([]);

    setClienteFilter(null);
    setcolaboradorFilter(null);
    setAddColabOpen(false);
    setColaboradorSelected([]);

    setLocalFilter(null);
    setProdutoLenteCodigo(null);
    setProdutoLenteDescricaoSelected(null);
    setProdutoAroCodigo(null);
    setProdutoAroDescricaoSelected(null);

    setLenteTipoSelected(null);
    setLenteTratamentoSelected(null);
    setLenteReflexoSelected(null);
    setLenteRiscoSelected(null);
    setLenteODEsf("");
    setLenteODCili("");
    setLenteODEixo("");
    setLenteODDNP("");
    setLenteOEEsf("");
    setLenteOECili("");
    setLenteOEEixo("");
    setLenteOEDNP("");
    setLenteAdicao("");
    setLenteAltura("");
    setLenteSelected({
      label: "Par",
      id: "P",
    });

    setAroCor("");
    setAroTamanho("0");
    setAroAjuste(null);
    setAroHaste(null);
    setAroFrente(null);

    setColabNome("");
    setColabEmail("");
    setColabCPF("");
    setColabRG("");
    setColabActive(false);
    setColabId(null);
    let date = new Date();
    setPrecricaoDataValidade(
      formatDate({
        date: new Date(date.getFullYear() + 1, date.getMonth(), date.getDate()),
        separator: "-",
        format: "yyyy-mm-dd",
      })
    );
    setReceitaTObs("");
    setAutoVariavies([]);
  };

  return {
    handleChangeOpenAcordion,
    clientGetOptionLabel,
    handleAddColaborador,
    clearColaborador,
    handleBackSubmit,
    handleAddPrescricao,
    handleAutoPrescricao,
    HandleAddModalColaborador,
    clearAll,
  };
}
